import { ChangeDetectorRef, Component, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { IonContent, IonSearchbar, ItemReorderEventDetail, ModalController } from '@ionic/angular';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { TextSnippet, TextmodulesService } from 'src/app/_provider/textmodules/textmodules.service';
import { PopoverListItem, PopoverPage } from 'src/app/_template/popover/popover.page';
import { ContentTextModuleEditPage } from './content-text-module-edit/content-text-module-edit.page';
import { ArrowKeysOptions } from 'src/app/_directives/ArrowKeysUseable.directive';
import { ContentTextModulePreviewPage } from './content-text-module-preview/content-text-module-preview.page';



@Component({
  selector: 'app-content-text-module',
  templateUrl: './content-text-module.page.html',
  styleUrls: ['./content-text-module.page.scss'],
})
export class ContentTextModulePage implements OnInit {

  public snippets: TextSnippet[] = []
  public snippetsFiltered: TextSnippet[] = []
  public selectedSnippet: TextSnippet

  public showFooter: boolean = true

  public loadingContent: boolean = false
  public loadingList: boolean = true
  public searchText: string = ""

  public disableReorder: boolean = true

  @ViewChild('searchbar') searchbar: IonSearchbar;
  @ViewChild('ioContent') ionContent: IonContent;


  public arrowKeysOptions: ArrowKeysOptions = {
    selectedItem: -1,
    mouseOverItem: new EventEmitter<number>(null),
    mouseMove: new EventEmitter<boolean>(null),
    clearSelectedItem: new EventEmitter<boolean>(null),
    enterPressed: (index: number) =>{
      if(this.selectedSnippet?.id == this.snippetsFiltered[index]?.id) this.selectActiveModule()
      else this.selectModule(this.snippetsFiltered[index])
    }
  }

  constructor(
    private feedback: FeedbackService,
    private modalCtrl: ModalController,
    private changeDetector: ChangeDetectorRef,
    private textmodulesSrv: TextmodulesService,  
  ) { }

  async ngOnInit() {
    await this.loadAllSnippets()
    this.snippetsFiltered = [...this.snippets]
    await this.searchbar.setFocus()
  }

  ngAfterViewInit(){
    this.arrowKeysOptions.ionContent = this.ionContent
  }

  public async loadAllSnippets(){
    const result: HttpFunctionResult<TextSnippet[]> = await this.textmodulesSrv.getAllSnippets()
    this.loadingList = false
    if(!result.success) return
    this.snippets = result.data
  }

  public async close(){
    await this.modalCtrl.dismiss()
  }

  public async search(){
    this.selectedSnippet = undefined
    this.arrowKeysOptions.clearSelectedItem.emit(true)
    this.snippetsFiltered = this.snippets.filter(s => s.title.toLowerCase().includes(this.searchText.toLowerCase()))
    if(this.snippetsFiltered.length > 0){
      this.arrowKeysOptions.selectedItem = 0
      this.changeDetector.detectChanges()
      this.arrowKeysOptions.updateDOM()
    }
  }

  public async openModuleActions(event: Event, snippet: TextSnippet){
    
    event.stopPropagation()

    const list: PopoverListItem[] = [
      {id: 1, description: "Bearbeiten", icon: "fa-pen"},
      {id: 2, description: "Löschen", icon: "fa-trash", danger: true},
    ]

    if(window.matchMedia('(max-width: 899px)').matches){
      list.unshift({id: 3, description: "Vorschau", icon: "fa-eye"})
    }
    
    await this.feedback.openPopover(PopoverPage, event, {list}, async (result: HttpFunctionResult<PopoverListItem>)=>{
      if(!result.success) return
      switch (result.data.id) {
        case 1: this.editTextModule(snippet); break;
        case 2: this.deleteModule(snippet); break;
        case 3: await this.feedback.openModal(ContentTextModulePreviewPage, {snippet})
      }
    })
  }

  public async deleteModule(snippet: TextSnippet){
    if(!(await this.feedback.confirm(`Soll das Textbaustein "${snippet.title}" wirklich gelöscht werden?`, "Löschen", "Abbrechen"))) return
    await this.feedback.showLoading(async ()=>{
      const result: HttpFunctionResult<any> = await this.textmodulesSrv.deleteSnippet(snippet)
      if(result.success) {
        if(snippet.id == this.selectedSnippet?.id) {
          this.selectedSnippet = undefined
          this.arrowKeysOptions.selectedItem = -1
          this.arrowKeysOptions.updateDOM()
        }
        this.snippets = this.snippets.filter(tm => tm.id != snippet.id)
        this.snippetsFiltered = this.snippetsFiltered.filter(tm => tm.id != snippet.id)
      }
    },"Löschen...") 

  }

  public async addTextModule(){
    await this.feedback.openModal(ContentTextModuleEditPage, {}, (result: HttpFunctionResult<TextSnippet>)=>{
      if(!result.success) return
      this.searchText = ""
      this.snippets = [...this.snippets, result.data]
      this.snippetsFiltered = [...this.snippets]
      this.changeDetector.detectChanges()
    }, true, undefined, "modal-content-text-module")
  }

  public async editTextModule(snippet: TextSnippet){
    this.arrowKeysOptions.active = false

    let snippetResponse: HttpFunctionResult<TextSnippet>

    await this.feedback.showLoading(async () => {
      snippetResponse = await this.textmodulesSrv.getSnippetById(snippet.id)
    }, "Laden...")

    if(!snippetResponse?.success) return
    await this.feedback.openModal(ContentTextModuleEditPage, {
      snippet: snippetResponse.data, 
      isNew: false
    }, (result: HttpFunctionResult<TextSnippet>)=>{
      this.arrowKeysOptions.active = true
      if(result.success) {
        this.snippets.find(s => s.id == result.data.id).title = result.data.title
        if(this.selectedSnippet?.id == result.data.id) this.selectedSnippet.content = result.data.content
      }
      
      
    }, true, undefined, "modal-content-text-module")

  }

  public async selectModule(module: TextSnippet){
    // await this.modalCtrl.dismiss(module)
    this.loadingContent = true
    this.selectedSnippet = module
    const result: HttpFunctionResult<TextSnippet> = await this.textmodulesSrv.getSnippetById(module.id)
    this.loadingContent = false
    if(!result.success) return

    this.selectedSnippet.content = result.data.content

  }

  public async selectActiveModule(){
    if(!this.selectedSnippet) return await this.feedback.showError("Bitte wählen Sie einen Textbaustein aus.")
    await this.modalCtrl.dismiss(this.selectedSnippet)
  }

  public async handleReorder(event: CustomEvent<ItemReorderEventDetail>) {
    event.detail.complete(this.snippetsFiltered);
    const sortList: {key: number, value: number}[] = this.snippetsFiltered.map((s, index) => ({key: s.id, value: index}))
    await this.textmodulesSrv.updateSort(sortList)
  }
}
